import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useEffect, useState } from 'react';

function _useGuards(guards) {
  var _useState = useState({
    isLoading: true,
    shouldActivate: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var guardsActivations = guards.map(function (g) {
    return g.canActivate();
  });

  if (guardsActivations.every(function (g) {
    return g === true || g === false;
  })) {
    var shouldActivate = guardsActivations.reduce(function (m, v) {
      return m && v;
    }, true);
    useEffect(function () {
      guards.forEach(function (g) {
        var _g$didActivate, _g$didNotActivate;

        return shouldActivate ? (_g$didActivate = g.didActivate) === null || _g$didActivate === void 0 ? void 0 : _g$didActivate.call(g) : (_g$didNotActivate = g.didNotActivate) === null || _g$didNotActivate === void 0 ? void 0 : _g$didNotActivate.call(g);
      });
    }, [shouldActivate].concat(_toConsumableArray(guards)));
    return {
      isLoading: false,
      shouldActivate: shouldActivate
    };
  }

  useEffect(function () {
    var _checkGuards = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var shouldActivate, _iterator, _step, activation;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                shouldActivate = true;
                _iterator = _createForOfIteratorHelper(guardsActivations);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 14;
                  break;
                }

                activation = _step.value;
                _context.t0 = shouldActivate;

                if (!_context.t0) {
                  _context.next = 11;
                  break;
                }

                _context.next = 10;
                return activation;

              case 10:
                _context.t0 = _context.sent;

              case 11:
                shouldActivate = _context.t0;

              case 12:
                _context.next = 4;
                break;

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t1 = _context["catch"](2);

                _iterator.e(_context.t1);

              case 19:
                _context.prev = 19;

                _iterator.f();

                return _context.finish(19);

              case 22:
                setState({
                  isLoading: false,
                  shouldActivate: shouldActivate
                });
                guards.forEach(function (g) {
                  var _g$didActivate2, _g$didNotActivate2;

                  return shouldActivate ? (_g$didActivate2 = g.didActivate) === null || _g$didActivate2 === void 0 ? void 0 : _g$didActivate2.call(g) : (_g$didNotActivate2 = g.didNotActivate) === null || _g$didNotActivate2 === void 0 ? void 0 : _g$didNotActivate2.call(g);
                });

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 16, 19, 22]]);
      }));

      return function _checkGuards() {
        return _ref.apply(this, arguments);
      };
    }();

    _checkGuards();
  }, []);
  return state;
}

export var Guards = function Guards(_ref2) {
  var guards = _ref2.guards,
      children = _ref2.children;

  var _useGuards2 = _useGuards(guards),
      isLoading = _useGuards2.isLoading,
      shouldActivate = _useGuards2.shouldActivate;

  if (isLoading) {
    return null;
  }

  if (!shouldActivate) {
    return null;
  }

  return children;
};